module.exports = __webpack_public_path__ + "static/media/pic_4.2ed99762.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/pic_4.png
// module id = 519
// module chunks = 0